/** ========================================================================= *\
 * @prefab Scores
 * ========================================================================== */
import { drawRectWithBorder } from 'utils/draw';
import * as CONST from 'config';

class Scores extends Phaser.Group {

  /** @constructor */
  constructor(game, opts) {
    super(game);

    // Draw Scores
    let scores = this.game.scores;
    const markerY = CONST.HUD_PADDING +CONST.HUD_PADDING;
    const markerX = CONST.HUD_PADDING;
    this.fixedToCamera = true;

    // Draw text
    const text = new Phaser.Text(game, markerX, markerY, `${scores}m`, {
      font: '20px Futura-book',
      fill: '#ffffff',
      boundsAlignH: 'center',
      boundsAlignV: 'middle',
      align: 'center',
    });
    // text.anchor.set(0.5, 0.4);
    this.add(text);
  }
  update (){
    let scores = this.game.scores.toFixed();
    this.children[0].setText(`${scores} coins`);
  }
}

export default Scores;


// WEBPACK FOOTER //
// ./js/prefabs/scores.js